import noLayout from '../../layout/noLayout.vue';
const homeRouter = {
	path: '/',
	component: noLayout,
	redirect: '/',
	name: 'edu',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/about',
			component: () =>
				import('@/pages/ideological/views/about/newLineAbout.vue'),
			name: 'about',
		},
		{
			path: '/productIntroduce',
			component: () =>
				import('@/pages/ideological/views/about/productIntroduce.vue'),
			name: 'about',
		},
	],
};

export default homeRouter;
